function ensureHttps(url: string): string {
  return url.replace('http://', 'https://');
}

export default ensureHttps;
